import { DeviceTable } from '../typescript-axios';
import { DeviceModelType, deviceLabels, DeviceState } from '@marsinet/commons';

export interface Device {
  id?: string;
  d_id?: string;
  model: number;
  device_state?: DeviceState;
  serial: string;
  device_number?: string;
  structure_version: string;
  ceb_version?: string;
  esp_version?: string;
  epos_version?: string;
  app_version?: string;
  password: string;
  battery_cycles?: number;
  mpb_version?: string;
  mcb_version?: string;
  scb_version?: string;
  total_device_steps?: number;
  total_device_time?: number;
}

export interface TableDevicesComponentProps {
  filtersDevices: DeviceTable[];
  goToDevice: (row: DeviceTable) => void;
  loading: boolean;
}

// DeviceModelType and deviceLabels are now exported from @marsinet/commons
export { DeviceModelType, deviceLabels };

export interface ModalAddDeviceProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  createDeviceFunction: (values: {
    serial: string;
    model: number;
    password: string;
    structure_version: string;
    o_id: string;
  }) => void;
}
